import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";

function MobileMenu({ isOpen, onClose }) {
    const [activeMenu, setActiveMenu] = useState(null);
    const menuRefs = useRef({});

    // toggle dropdown
    const toggleMenu = (index) => {
        setActiveMenu(activeMenu === index ? null : index);
    };

    // animate height
    useEffect(() => {
        Object.keys(menuRefs.current).forEach((key) => {
            const submenu = menuRefs.current[key];
            if (submenu) {
                submenu.style.height =
                    activeMenu == key ? `${submenu.scrollHeight}px` : "0px";
            }
        });
    }, [activeMenu]);

    return (
        <div
            className={`th-menu-wrapper onepage-nav ${isOpen ? "th-body-visible" : ""}`}
            style={{ visibility: isOpen ? "visible" : "hidden" }}
        >
            <div className="th-menu-area text-center">
                <button className="th-menu-toggle" onClick={onClose} aria-label="Close">
                    <i className="fal fa-times" />
                </button>

                <div className="mobile-logo">
                    <Link to="/">
                        <img src="/assets/img/logo2.svg" alt="Tourm" />
                    </Link>
                </div>

                <div className="th-mobile-menu">
                    <ul>
                        {/* Home */}
                        <li>
                            <Link to="/">Home</Link>
                        </li>

                        {/* Destinations */}
                        <li
                            className={`menu-item-has-children th-item-has-children ${
                                activeMenu === 1 ? "th-active" : ""
                            }`}
                        >
                            <Link to="#" onClick={() => toggleMenu(1)}>
                                Destinations
                            </Link>
                            <ul
                                ref={(el) => (menuRefs.current[1] = el)}
                                className="th-submenu"
                                style={{
                                    height: "0px",
                                    overflow: "hidden",
                                    transition: "height 0.3s ease-in-out",
                                }}
                            >
                                <li><Link>Top Countries</Link></li>
                                <li><Link>East Africa</Link></li>
                                <li><Link>East Africa Combos</Link></li>
                                <li><Link>Southern Africa</Link></li>
                                <li><Link>Southern Africa Combos</Link></li>
                                <li><Link>Island & Coastal Escapes</Link></li>
                                <li><Link>Other African Destinations</Link></li>
                            </ul>
                        </li>

                        {/* Safaris */}
                        <li
                            className={`menu-item-has-children th-item-has-children ${
                                activeMenu === 2 ? "th-active" : ""
                            }`}
                        >
                            <Link to="#" onClick={() => toggleMenu(2)}>
                                Safaris
                            </Link>
                            <ul
                                ref={(el) => (menuRefs.current[2] = el)}
                                className="th-submenu"
                                style={{
                                    height: "0px",
                                    overflow: "hidden",
                                    transition: "height 0.3s ease-in-out",
                                }}
                            >
                                <li><Link>Safari Experiences</Link></li>
                                <li><Link>Photography Trips</Link></li>
                                <li><Link>Family Adventures</Link></li>
                                <li><Link>Romantic Escapes</Link></li>
                                <li><Link>Beach & Bush</Link></li>
                                <li><Link>Active Adventures</Link></li>
                                <li><Link>Group Departures</Link></li>
                                <li><Link>Last-Minute Deals</Link></li>
                                <li><Link>Honeymoon Getaways</Link></li>
                            </ul>
                        </li>

                        {/* Discover */}
                        <li
                            className={`menu-item-has-children th-item-has-children ${
                                activeMenu === 3 ? "th-active" : ""
                            }`}
                        >
                            <Link to="#" onClick={() => toggleMenu(3)}>
                                Discover
                            </Link>
                            <ul
                                ref={(el) => (menuRefs.current[3] = el)}
                                className="th-submenu"
                                style={{
                                    height: "0px",
                                    overflow: "hidden",
                                    transition: "height 0.3s ease-in-out",
                                }}
                            >
                                <li><Link>AAC Events</Link></li>
                                <li><Link>Client Trip Reports</Link></li>
                                <li><Link>Expert Recommendations</Link></li>
                                <li><Link>Photo & Video Highlights</Link></li>
                                <li><Link>Accommodations</Link></li>
                                <li><Link>Parks & Reserves</Link></li>
                                <li><Link>Best Time To Visit</Link></li>
                            </ul>
                        </li>

                        {/* Planning */}
                        <li
                            className={`menu-item-has-children th-item-has-children ${
                                activeMenu === 4 ? "th-active" : ""
                            }`}
                        >
                            <Link to="#" onClick={() => toggleMenu(4)}>
                                Planning
                            </Link>
                            <ul
                                ref={(el) => (menuRefs.current[4] = el)}
                                className="th-submenu"
                                style={{
                                    height: "0px",
                                    overflow: "hidden",
                                    transition: "height 0.3s ease-in-out",
                                }}
                            >
                                <li><Link>Why Travel Africa?</Link></li>
                                <li><Link>Travel FAQs</Link></li>
                                <li><Link>Safari Products</Link></li>
                                <li><Link>Best Time To Go</Link></li>
                                <li><Link>Request Safari Planner</Link></li>
                            </ul>
                        </li>

                        {/* Our Story */}
                        <li
                            className={`menu-item-has-children th-item-has-children ${
                                activeMenu === 5 ? "th-active" : ""
                            }`}
                        >
                            <Link to="#" onClick={() => toggleMenu(5)}>
                                Our Story
                            </Link>
                            <ul
                                ref={(el) => (menuRefs.current[5] = el)}
                                className="th-submenu"
                                style={{
                                    height: "0px",
                                    overflow: "hidden",
                                    transition: "height 0.3s ease-in-out",
                                }}
                            >
                                <li><Link>Meet The Team</Link></li>
                                <li><Link>Meet Our Guides</Link></li>
                                <li><Link>Impact & Giving Back</Link></li>
                                <li><Link>Awards & Press</Link></li>
                                <li><Link>Why Travel With Us</Link></li>
                                <li><Link>Traveler Reviews</Link></li>
                            </ul>
                        </li>

                        {/* Contact */}
                        <li>
                            <Link>Contact Us</Link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default MobileMenu;
